/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { BoletoRequest } from '../models/boleto-request';
import { Message } from '../models/message';

/**
 * API responsavel por gerar boleto
 */
@Injectable({
  providedIn: 'root',
})
class BoletoService extends __BaseService {
  static readonly obterBoletoPath = '/boleto';
  static readonly gerarSegundaViaBoletoPath = '/boleto/gerarSegundaViaBoleto/{codigoAcordo}/{codigoParcela}/{enderecoEmail}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Retorna boleto com base nos parametros informados
   * @param boletoRequest Objeto boleto request
   * @return Boleto gerado com sucesso
   */
  obterBoletoResponse(boletoRequest: BoletoRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = boletoRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/boleto`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna boleto com base nos parametros informados
   * @param boletoRequest Objeto boleto request
   * @return Boleto gerado com sucesso
   */
  obterBoleto(boletoRequest: BoletoRequest): __Observable<Blob> {
    return this.obterBoletoResponse(boletoRequest).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Enviar por email segunda via do boleto com base nos parametros informados
   * @param params The `BoletoService.GerarSegundaViaBoletoParams` containing the following parameters:
   *
   * - `enderecoEmail`: Endereco de Email
   *
   * - `codigoParcela`: Codigo da parcela
   *
   * - `codigoAcordo`: Codigo identificador do acordo
   *
   * @return Operacao realizada com sucesso
   */
  gerarSegundaViaBoletoResponse(params: BoletoService.GerarSegundaViaBoletoParams): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/boleto/gerarSegundaViaBoleto/${encodeURIComponent(String(params.codigoAcordo))}/${encodeURIComponent(String(params.codigoParcela))}/${encodeURIComponent(String(params.enderecoEmail))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Enviar por email segunda via do boleto com base nos parametros informados
   * @param params The `BoletoService.GerarSegundaViaBoletoParams` containing the following parameters:
   *
   * - `enderecoEmail`: Endereco de Email
   *
   * - `codigoParcela`: Codigo da parcela
   *
   * - `codigoAcordo`: Codigo identificador do acordo
   *
   * @return Operacao realizada com sucesso
   */
  gerarSegundaViaBoleto(params: BoletoService.GerarSegundaViaBoletoParams): __Observable<Message> {
    return this.gerarSegundaViaBoletoResponse(params).pipe(
      __map(_r => _r.body as Message)
    );
  }
}

module BoletoService {

  /**
   * Parameters for gerarSegundaViaBoleto
   */
  export interface GerarSegundaViaBoletoParams {

    /**
     * Endereco de Email
     */
    enderecoEmail: string;

    /**
     * Codigo da parcela
     */
    codigoParcela: number;

    /**
     * Codigo identificador do acordo
     */
    codigoAcordo: number;
  }
}

export { BoletoService }
